"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _fixBabelExtend = function (O) {
    var gPO = O.getPrototypeOf || function (o) {
        return o.__proto__;
    },
        sPO = O.setPrototypeOf || function (o, p) {
        o.__proto__ = p;
        return o;
    },
        construct = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === 'object' ? Reflect.construct : function (Parent, args, Class) {
        var Constructor,
            a = [null];
        a.push.apply(a, args);
        Constructor = Parent.bind.apply(Parent, a);
        return sPO(new Constructor(), Class.prototype);
    };

    return function fixBabelExtend(Class) {
        var Parent = gPO(Class);
        return sPO(Class, sPO(function Super() {
            return construct(Parent, arguments, gPO(this).constructor);
        }, Parent));
    };
}(Object);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright 2017-2018 The MathWorks, Inc.
/* global Reflect */
define(["custom-elements/custom-elements.min"], function () {
    var PatchedHtmlElement = void 0;
    if (((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) !== "object" || !Reflect.construct) && document.__CE_hasRegistry) {
        // IE11 (and possibly QTWebKit) does not have Reflect.construct
        // This causes problems when we are extending from the HTMLElement polyfill.
        //
        // If we are in this if, We are in Polyfill Mode (document.__CE_hasRegistry)
        // without Reflect.contruct
        // Do NOT treat HTMLElement as a built-in

        // If we do the polyfill will complain:
        // The custom element being constructed was not registered with `customElements`
        // We can switch over to directly extending custom element without the intermediate
        // class if Reflect.construct is available in all of our supported browsers
        //
        // To avoid treating "HTMLElement" as a built-in, it is not directly extended.
        // Instead it is copied to a variable _HTMLElement and then extended.  Because
        // Babel does not do static analysis, and the built in names are "Hard Coded"
        // this causes Babel to treat this as a standard extension, and not a built-in
        // extension
        var _HTMLElement = HTMLElement;
        PatchedHtmlElement = function (_HTMLElement2) {
            _inherits(PatchedHtmlElement, _HTMLElement2);

            function PatchedHtmlElement() {
                _classCallCheck(this, PatchedHtmlElement);

                return _possibleConstructorReturn(this, (PatchedHtmlElement.__proto__ || Object.getPrototypeOf(PatchedHtmlElement)).apply(this, arguments));
            }

            return PatchedHtmlElement;
        }(_HTMLElement);
    } else {
        PatchedHtmlElement = _fixBabelExtend(function (_HTMLElement3) {
            _inherits(_class, _HTMLElement3);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            return _class;
        }(HTMLElement));
    }

    return PatchedHtmlElement;
});

